import './LoggedIn.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import TestList from '../Test/List/TestList'
import TestRoot from '../Test/Root/TestRoot'
import ScoreReport from '../Test/ScoreReport/ScoreReport'
import Settings from '../Settings/Settings'
import DeleteAccount from '../Settings/DeleteAccount'
import TestStoreList from '../TestStore/TestStoreList'
import TestApplicationForm from '../TestStore/TestApplicationForm'
import PaymentSuccess from '../TestStore/PaymentSuccess'
import PaymentFail from '../TestStore/PaymentFail'
import TestTerms from '../TestStore/TestTerms'
import LevelTest from '../ExamStore/LevelTest'
import NavBar from '../Base/NavBar'
import PrivatePolicy from '../LoggedOut/PrivatePolicy/PrivatePolicy'
import TermsOfService from '../LoggedOut/TermsOfService/TermsOfService'

function LoggedIn() {
    return <div>
        <BrowserRouter>
            <NavBar></NavBar>
            <div className="safe-area">
                <Routes>
                    <Route path="/" element={<TestList />} />
                    <Route path="/tests" element={<TestList />} />
                    <Route path="/tests/:testId" element={<TestRoot />} />
                    <Route path="/tests/:testId/score-report" element={<ScoreReport />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/settings/delete-account" element={<DeleteAccount />} />
                    <Route path="/test-store" element={<TestStoreList />} />
                    <Route path="/test-store/application" element={<TestApplicationForm />} />
                    <Route path="/test-store/payment/success" element={<PaymentSuccess />} />
                    <Route path="/test-store/payment/fail" element={<PaymentFail />} />
                    <Route path="/test-terms" element={<TestTerms />} />
                    <Route path="/test-store/level-test" element={<LevelTest />} />
                    <Route path="/privacy-policy" element={<PrivatePolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                </Routes>
            </div>
        </BrowserRouter>
    </div>
}

export default LoggedIn;